import React from 'react';

export default function Footer() {
  return (
    <footer className="d-footer">
      <div className="row align-items-center justify-content-between">
        <div className="col-auto">
          <p className="mb-0">© 2025 DDS ERP. All Rights Reserved.</p>
        </div>
        <div className="col-auto">
          <p className="mb-0">
            Made by <span className="text-primary-600">digitaldatasystem</span>
          </p>
        </div>
      </div>
    </footer>
  );
}